import { render } from "./NotificationWidget.vue?vue&type=template&id=9cd4bffa&scoped=true"
import script from "./NotificationWidget.vue?vue&type=script&lang=js"
export * from "./NotificationWidget.vue?vue&type=script&lang=js"

import "./NotificationWidget.vue?vue&type=style&index=0&id=9cd4bffa&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9cd4bffa"]])

export default __exports__